export enum CameraAttachmentsConstants {
  SAVE_IMAGE = 'cameraAttachments/SAVE_IMAGE',
  SET_IMAGE = 'cameraAttachments/SET_IMAGE',
  SET_NAME = 'cameraAttachments/SET_NAME',
  SET_CATEGORY = 'cameraAttachments/SET_CATEGORY',
  RESET_STATE = 'cameraAttachments/RESET_STATE',
  SET_CAMERA_ATTACHMENTS_LIST = 'cameraAttachments/SET_CAMERA_ATTACHMENTS_LIST',
  SET_DISABLE_CAMERA_BUTTON = 'cameraAttachments/SET_DISABLE_CAMERA_BUTTON',
}
